"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitalSignatureButton = exports.useSignatureButtonStyles = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var hooks_1 = require("../hooks");
var SignIcon_1 = require("../resources/icons/SignIcon");
var __1 = require("..");
var modals_1 = require("./modals");
exports.useSignatureButtonStyles = core_1.makeStyles(function (theme) {
    var signature = theme.variables.palette.crypto.signature;
    return {
        button: {
            '&:hover svg': {
                fill: theme.palette.secondary.dark,
            },
        },
        icon: {
            fill: function (_a) {
                var signatureStatus = _a.signatureStatus, isView = _a.isView;
                switch (signatureStatus) {
                    case 'without':
                        if (isView) {
                            return signature.defaultView;
                            break;
                        }
                        return signature.defaultEdit;
                        break;
                    case 'valid':
                        return signature.valid;
                        break;
                    case 'invalid': {
                        return signature.invalid;
                    }
                }
            },
        },
    };
});
exports.DigitalSignatureButton = mobx_react_1.observer(function (props) {
    var fileDownloadComponent = props.fileDownloadComponent, signatureStatus = props.signatureStatus, isView = props.isView;
    var _a = hooks_1.useModal(), isAddSignatureOpen = _a[0], setAddSignatureModalIsOpen = _a[1], setAddSignatureModalIsClosed = _a[2];
    var _b = hooks_1.useModal(), isOpenSignatureInfo = _b[0], setSignatureInfoModalIsOpen = _b[1], setSignatureInfoModalIsClosed = _b[2];
    var classes = exports.useSignatureButtonStyles({ signatureStatus: signatureStatus, isView: isView });
    var isWithoutSignature = signatureStatus === __1.SignatureStatus.WITHOUT;
    var isDisabledButton = isView && isWithoutSignature;
    var tooltipMessage = react_1.useMemo(function () {
        switch (signatureStatus) {
            case __1.SignatureStatus.WITHOUT:
                return react_1.default.createElement(react_intl_1.FormattedMessage, { id: "absent" });
                break;
            case __1.SignatureStatus.INVALID:
                return react_1.default.createElement(react_intl_1.FormattedMessage, { id: "unableSignature" });
                break;
            case __1.SignatureStatus.VALID:
                return react_1.default.createElement(react_intl_1.FormattedMessage, { id: "viewSignature" });
                break;
        }
    }, [signatureStatus]);
    var handleModalOpen = react_1.useCallback(function () {
        if (isWithoutSignature) {
            return setAddSignatureModalIsOpen();
        }
        return setSignatureInfoModalIsOpen();
    }, [signatureStatus, isWithoutSignature]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isAddSignatureOpen && (react_1.default.createElement(modals_1.AddSignatureModal, { onClose: setAddSignatureModalIsClosed, fileDownloadComponent: fileDownloadComponent })),
        isOpenSignatureInfo && (react_1.default.createElement(__1.SignatureInfoModal, { isView: isView, onClose: setSignatureInfoModalIsClosed, signatureStatus: signatureStatus })),
        react_1.default.createElement(core_1.Tooltip, { title: tooltipMessage },
            react_1.default.createElement("span", null,
                react_1.default.createElement(core_1.IconButton, { color: "secondary", className: classes.button, onClick: handleModalOpen, disabled: isDisabledButton, id: "signature-icon" },
                    react_1.default.createElement(SignIcon_1.SignIcon, { className: classes.icon }))))));
});
